export const AUTH_ENDPOINTS = {
    ME: '/v1/auth/me',
    LOGIN: '/v1/auth/login',
    LOGOUT: '/v1/auth/logout',
    SIGNUP: '/v1/auth/signup',
    DELETE: '/v1/auth/delete',
    CHECKEMAIL: (email: string) => `/v1/auth/available/email/${email}`,
    CHECKPHONE: (phone: string) => `/v1/auth/available/phone/${phone}`,
    CHECKPROFILEID: '/v1/auth/available/profile-id'
  } as const;
  
  export const WORKSPACE_ENDPOINTS = {
    LIST: '/v1/hub/workspaces',
    DETAIL: (workspaceName: string) => `/v1/hub/workspaces/${workspaceName}`,
    CREATE: '/v1/hub/workspaces',
    CHECK_ID: (id: string) => `/v1/hub/workspaces/available/workspace-id/${id}`,
    CHECK_DESCRIPTION: (description: string) => `/v1/hub/workspaces/available/description/${description}`
  } as const;
  
  export const COMPANY_ENDPOINTS = {
    LIST: (workspaceName: string) => `/v1/hub/companies/by-workspace/${workspaceName}`,
    GETDATA: (companyId: string) => `/v1/hub/companies/${companyId}`,
    UPDATE: (companyId: string) => `/v1/hub/companies/${companyId}`,
    HOMETAX: {
      SAVE: (companyId: string) => `/v1/hub/companies/${companyId}/hometax`,
      DELETE: (companyId: string) => `/v1/hub/companies/${companyId}/hometax`,
      CREDENTIAL: (companyId: string) => `/v1/hub/companies/${companyId}/credential`

    }
  } as const;
  
  export const EXTERNAL_ENDPOINTS = {
    ACCOUNTING: 'http://act.xadom.ai:8001/Main',
    BIZNUM_CHECK: 'https://api.odcloud.kr/api/nts-businessman/v1/status'
  } as const;

  export const ACCOUNTING_ENDPOINTS = {
    CARD_COLLECT: '/v1/accounting/transactions/card/collect'
  } as const;
